export default "__VITE_ASSET__CipA__72__"